import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Table from '../../../../../component/table/Table';
import ArrowUp from '../../../../../assets/image/arrow_up.svg';
import ArrowDown from '../../../../../assets/image/arrowD.svg';
import { creditNoteColumn } from '../../../components/tableColumns';

const PaymentReceivedTabs = ({ creditNoteList }) => {
	const [isIndexTableTab, setIsNameTableTab] = useState(0);
	const [isShowTableTab, setIsShowTableTab] = useState(false);
	const navigate = useNavigate();
	const suburl = localStorage.getItem('suburl');

	return (
		<div>
			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
					alignItems: 'center',
					backgroundColor: '#F6F6F9',
				}}
			>
				<div className="tabs">
					<div
						className={`tab ${isIndexTableTab === 0 ? 'active' : 'inactive'}`}
						onClick={() => {
							setIsNameTableTab(0);
							setIsShowTableTab(true);
						}}
						style={{ fontSize: '16px', fontWeight: 'bold' }}
					>
						Credit Note
						<span
							style={{
								borderRadius: '5px',
								color: '#3B58FF',
								marginLeft: '7px',
							}}
						>
							{creditNoteList.length ?? 0}
						</span>
					</div>
				</div>
				<div
					style={{
						padding: '0px 10px',
					}}
				>
					{isShowTableTab ? (
						<img
							style={{
								cursor: 'pointer',
							}}
							alt="Arrow_up"
							src={ArrowUp}
							onClick={() => setIsShowTableTab(false)}
						/>
					) : (
						<img
							style={{
								cursor: 'pointer',
							}}
							alt="Arrow_down"
							src={ArrowDown}
							onClick={() => setIsShowTableTab(true)}
						/>
					)}
				</div>
			</div>

			{isShowTableTab && isIndexTableTab === 0 && (
				<div className="table">
					<Table
						coloum={creditNoteColumn}
						row={creditNoteList}
						onRowClick={(rowId) => {
							navigate(`/user/${suburl}/sales/credit-note-details/${rowId}`);
						}}
						style={{ height: '210px', padding: '0%' }}
					/>
				</div>
			)}
		</div>
	);
};
export default PaymentReceivedTabs;
